export enum ChecklistCategory {
	MonthlyInspectionReport = "Monthly Inspection Report",
	UserAcceptance = "User Acceptance",
}

export const checklistCategoryOptions = [
	{ value: ChecklistCategory.MonthlyInspectionReport, label: ChecklistCategory.MonthlyInspectionReport },
	{ value: ChecklistCategory.UserAcceptance, label: ChecklistCategory.UserAcceptance },
];
